import { createNanoEvents } from "nanoevents";
import type { OpenCongratsModalEventPayload } from "shared/lib";

interface Events {
  OPEN_CONGRATS_MODAL: (payload: OpenCongratsModalEventPayload) => void;
  CLOSE_CONGRATS_MODAL: () => void;
}

export const emitter = createNanoEvents<Events>();
